import fetch from './fetch'

// 获取首页轮播图
export const getHomeCarousel = () => fetch(`/home-carousel/`, {method: 'get'})
// 获取首页详细信息
export const getHomeDetail = () => fetch(`/home/1/`, {method: 'get'})
export const getContactDetail = () => fetch(`/contact-us/1/`, {method: 'get'})
export const getService = () => fetch(`/provide-service/`, {method: 'get'})
export const searchExample = (pageJson = {}) => fetch(`/example/`, {method: 'get', params: pageJson}).then(function (res) {
  if (pageJson !== {} && 'page_size' in pageJson) {
    return [res.results, res.count]
  } else {
    return res
  }
})
export const getExampleDetail = (id) => fetch(`/example/${id}/`, {method: 'get'})
export const getExampleType = (pageJson = {}) => fetch('/example-type/', {method: 'get', params: {'is_active': true, ...pageJson}}).then(function (res) {
  if (pageJson !== {} && 'page_size' in pageJson) {
    return [res.results, res.count]
  } else {
    return res
  }
})
export const getOneExampleType = (id) => fetch(`/example-type/${id}/`, {method: 'get'})
export const getSettingInfo = () => fetch(`/setting-info/`, {method: 'get'})
export const getCooperationCompany = () => fetch(`/cooperation-company/`, {method: 'get'})
// 发送邮箱信息
// export const sendEmail = (pageJson = {}) => fetch(`/action/send-mail/`, {method: 'post', params: pageJson}).then(function (res) {
//   if (pageJson !== {} && 'page_size' in pageJson) {
//     return [res.results, res.count]
//   } else {
//     return res
//   }
// })
export const sendEmail = (params) => fetch('/action/send-mail/', { method: 'post', data: params })



// WEBPACK FOOTER //
// ./src/utils/api.js